var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 105,
    viewBox: "0 0 117 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.891 13.328H90.8782V5.21715C90.8782 2.5203 88.7163 0.350647 86.0291 0.350647H31.073C28.3859 0.350647 26.224 2.5203 26.224 5.21715V13.328H5.21137C2.52418 13.328 0.362305 15.4976 0.362305 18.1945V29.5497C0.362305 36.7886 4.9083 44.2303 12.8688 49.9687C19.2332 54.5716 26.9715 57.4915 35.0937 58.4243C41.4379 68.9887 48.8529 73.3482 48.8529 73.3482V87.9478H39.1548C32.0226 87.9478 26.224 92.1451 26.224 99.3029V101.736C26.224 103.074 27.315 104.169 28.6485 104.169H88.4536C89.7871 104.169 90.8782 103.074 90.8782 101.736V99.3029C90.8782 92.1451 85.0795 87.9478 77.9473 87.9478H68.2492V73.3482C68.2492 73.3482 75.6642 68.9887 82.0084 58.4243C90.1508 57.4915 97.8891 54.5716 104.233 49.9687C112.174 44.2303 116.74 36.7886 116.74 29.5497V18.1945C116.74 15.4976 114.578 13.328 111.891 13.328ZM20.4253 39.4449C15.4954 35.8761 13.2931 31.9018 13.2931 29.5497V26.3053H26.2644C26.4664 32.9157 27.4362 38.7149 28.8506 43.7842C25.7997 42.7298 22.9509 41.2699 20.4253 39.4449ZM103.809 29.5497C103.809 32.8143 100.233 36.8697 96.6768 39.4449C94.1513 41.2699 91.2822 42.7298 88.2314 43.7842C89.6457 38.7149 90.6155 32.9157 90.8175 26.3053H103.809V29.5497Z",
    fill: "#EF485D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.9b13be26162200a13ebd844c77260a2a.svg";
export { ForwardRef as ReactComponent };